module.exports = __webpack_public_path__ + "img/integratedLogo3.bc43fe7d.png";